import React from 'react'
import * as S from '../../styles'

export const FirstRowWidgets = ({
  notificationsAccessState,
  renderNotificationsWidget
}) => {
  const renderFirstRow = () => {
    if (notificationsAccessState) {
      return <S.Grid>{renderNotificationsWidget}</S.Grid>
    }
    return null
  }

  return <>{renderFirstRow()}</>
}

export default FirstRowWidgets
